export default "__VITE_ASSET__DEXk25Ql__"